/**
 * Projects MVI State
 *
 * State interfaces, initial state factory, and selectors.
 */

import type { IProject } from "@/shared/api";
import type { IApiError } from "@/shared/types";

// ============================================================================
// State Interface
// ============================================================================

export interface IProjectsState {
  readonly projects: readonly IProject[];
  readonly selectedProjectId: string;
  readonly isLoading: boolean;
  readonly isCreating: boolean;
  readonly error: IApiError | null;
}

// ============================================================================
// Initial State
// ============================================================================

export function createInitialState(): IProjectsState {
  return {
    projects: [],
    selectedProjectId: "",
    isLoading: false,
    isCreating: false,
    error: null,
  };
}

// ============================================================================
// Selectors
// ============================================================================

export function selectProjects(state: IProjectsState): readonly IProject[] {
  return state.projects;
}

export function selectSelectedProjectId(state: IProjectsState): string {
  return state.selectedProjectId;
}

export function selectIsLoading(state: IProjectsState): boolean {
  return state.isLoading;
}

export function selectIsCreating(state: IProjectsState): boolean {
  return state.isCreating;
}

export function selectError(state: IProjectsState): IApiError | null {
  return state.error;
}
